export default {
  backgroundColor: '#f4f4f4',
  menuBackground: '#ffffff',
  overlayColor: 'rgba(255, 255, 255,  0.5)',
  defaultColor: '#000000',
  mainTextColor: '#484d4d',
  detailsTitleTextColor: '#ffffff',
  detailsMetadataTextColor: 'rgba(255, 255, 255, 0.7)',
  epgBorderColor: 'rgba(0, 0, 0, 0.75)',
  epgTimeColor: 'rgba(0, 0, 0, 0.5)',
  secondaryTextColor: '#909999',
  activeColor: '#21A5AD',
  activeColorText: '#ffffff',
  secondaryActiveColor: '#ff994f',
  imagePlaceholder: '#191919',
  playerProgressBackground: 'rgba(255, 255, 255, 0.25)',
  playerProgressBuffer: 'rgba(255, 255, 255, 0.25)',
  playerProgressElapsed: 'rgba(255, 255, 255, 0.75)',
  playerCurrentPosition: 'rgba(255, 255, 255, 1)',
  playerTime: '#ffffff',
  playerButtonBg: 'rgba(255, 255, 255, 0.15)',
  modalOverlayColor: '#000',
  transparentModalOverlayColor: 'rgba(0, 0, 0, 0.95)',
};
